import { GRUPOS_DO_RESUMO, comNumero, type GrupoDoResumo, type Pendencia } from './tipos';

/**
 * O resumo: quatro números do dia, cada um um botão que filtra a pilha
 * (RN-256, 2).
 *
 * O número conta SITUAÇÕES — cartões —, não itens: «3 travado» são três
 * cartões, não três ensaios. Somar equipamento com amostra e com OS daria
 * um número sem unidade. Tocar num número deixa na pilha só as situações
 * dele (`aria-pressed`); tocar de novo volta a mostrar todas.
 *
 * Zero aparece, em cinza (`data-zero`): zero no resumo é notícia boa, e um
 * resumo que some quando está tudo bem faz a pessoa procurar o que faltou.
 * O botão do zero continua um botão — o número é lido pelo leitor de tela
 * junto com o rótulo, e filtrar por ele mostra a pilha vazia, que é a
 * verdade.
 */
export function ResumoDoPainel({ pendencias, filtro, aoFiltrar }: {
  pendencias: Pendencia[];
  filtro: GrupoDoResumo | null;
  aoFiltrar(g: GrupoDoResumo | null): void;
}) {
  const existentes = comNumero(pendencias);

  return (
    <div className="pn-resumo" role="group" aria-label="Resumo do dia">
      {GRUPOS_DO_RESUMO.map(({ grupo, rotulo }) => {
        const quantos = existentes.filter((p) => p.grupo === grupo).length;
        const marcado = filtro === grupo;
        return (
          <button
            key={grupo}
            type="button"
            className="pn-res"
            data-grupo={grupo}
            data-zero={quantos === 0 ? '' : undefined}
            aria-pressed={marcado}
            onClick={() => aoFiltrar(marcado ? null : grupo)}
          >
            <span className="pn-res-num">{quantos}</span>
            <span className="pn-res-rot">{rotulo}</span>
          </button>
        );
      })}
    </div>
  );
}
